function findReferences(obj, catalog) {
    // The catalogObject function walks recursively through an object graph
    // looking for $id properties. When it finds an object with that property, then
    // it adds it to the catalog under that key.
    let i;
    if (obj && typeof obj === "object") {
        const id = obj.$id;
        if (typeof id === "string") {
            catalog[id] = obj;
        }
        if (Object.prototype.toString.apply(obj) === "[object Array]") {
            for (i = 0; i < obj.length; i += 1) {
                findReferences(obj[i], catalog);
            }
        }
        else {
            for (const name in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, name)) {
                    if (typeof obj[name] === "object") {
                        findReferences(obj[name], catalog);
                    }
                }
            }
        }
    }
}
function resolveReferences(obj, catalog, _subCategory) {
    let i, item, name, id, refId;
    const subCatalog = Object.assign([], _subCategory);
    if (obj && typeof obj === "object") {
        if (Object.prototype.toString.apply(obj) === "[object Array]") {
            for (i = 0; i < obj.length; i += 1) {
                item = obj[i];
                if (item && typeof item === "object") {
                    id = item.$ref;
                    refId = item.$id;
                    if (typeof refId === "string")
                        subCatalog.push(refId);
                    if (!subCatalog.includes(id)) {
                        if (typeof id === "string") {
                            subCatalog.push(id);
                            obj[i] = resolveReferences(JSON.parse(JSON.stringify(catalog[id])), catalog, subCatalog);
                            if (subCatalog.indexOf(id) > -1)
                                subCatalog.splice(subCatalog.indexOf(id), 1);
                        }
                        else
                            obj[i] = resolveReferences(item, catalog, subCatalog);
                    }
                    if (subCatalog.indexOf(refId) > -1)
                        subCatalog.splice(subCatalog.indexOf(refId), 1);
                }
            }
        }
        else if (obj.$values && Object.prototype.toString.apply(obj.$values) === "[object Array]") {
            const arr = new Array([]);
            for (i = 0; i < obj.$values.length; i += 1) {
                item = obj.$values[i];
                if (item && typeof item === "object") {
                    id = item.$ref;
                    refId = item.$id;
                    if (typeof refId === "string")
                        subCatalog.push(refId);
                    if (!subCatalog.includes(id)) {
                        if (typeof id === "string") {
                            subCatalog.push(id);
                            arr[i] = resolveReferences(JSON.parse(JSON.stringify(catalog[id])), catalog, subCatalog);
                            if (subCatalog.indexOf(id) > -1)
                                subCatalog.splice(subCatalog.indexOf(id), 1);
                        }
                        else
                            arr[i] = resolveReferences(item, catalog, subCatalog);
                    }
                    if (subCatalog.indexOf(refId) > -1)
                        subCatalog.splice(subCatalog.indexOf(refId), 1);
                }
                else {
                    arr[i] = item;
                }
            }
            obj = arr;
        }
        else {
            for (const name in obj) {
                if (name)
                    if (Object.prototype.hasOwnProperty.call(obj, name)) {
                        if (typeof obj[name] === "object") {
                            item = obj[name];
                            if (item && item != undefined) {
                                id = item.$ref;
                                refId = item.$id;
                                if (typeof refId === "string")
                                    subCatalog.push(refId);
                                if (!subCatalog.includes(id)) {
                                    if (typeof id === "string") {
                                        subCatalog.push(id);
                                        obj[name] = resolveReferences(JSON.parse(JSON.stringify(catalog[id])), catalog, subCatalog);
                                        if (subCatalog.indexOf(id) > -1)
                                            subCatalog.splice(subCatalog.indexOf(id), 1);
                                    }
                                    else
                                        obj[name] = resolveReferences(item, catalog, subCatalog);
                                }
                                if (subCatalog.indexOf(refId) > -1)
                                    subCatalog.splice(subCatalog.indexOf(refId), 1);
                            }
                        }
                    }
            }
        }
    }
    return obj;
}
function getDecycledCopy(obj, catalog) {
    // The createReferences function recurses through the object, producing the deep copy.
    let i; // The loop counter
    let name; // Property name
    let nu; // The new object or array
    switch (typeof obj) {
        case "object":
            // typeof null === 'object', so get out if this value is not really an object.
            // Also get out if it is a weird builtin object.
            if (obj === null ||
                obj instanceof Boolean ||
                obj instanceof Date ||
                obj instanceof Number ||
                obj instanceof RegExp ||
                obj instanceof String) {
                return obj;
            }
            // If the value is an object or array, look to see if we have already
            // encountered it. If so, return a {$id:id} object. This is a hard way, O(n)
            // linear search that will get slower as the number of unique objects grows.
            // JavaScript really should have a decent dictionary or map class.
            for (i = 0; i < catalog.length; i += 1) {
                if (catalog[i] === obj) {
                    return { $ref: i.toString() };
                }
            }
            // Otherwise, accumulate the unique value and its id.
            obj.$id = catalog.length.toString();
            catalog.push(obj);
            // If it is an array, replicate the array.
            if (Object.prototype.toString.apply(obj) === "[object Array]") {
                nu = [];
                for (i = 0; i < obj.length; i += 1) {
                    nu[i] = getDecycledCopy(obj[i], catalog);
                }
            }
            else {
                // If it is an object, replicate the object.
                nu = {};
                for (name in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, name)) {
                        nu[name] = getDecycledCopy(obj[name], catalog);
                    }
                }
            }
            return nu;
        case "number":
        case "string":
        case "boolean":
        default:
            return obj;
    }
}
/** Make a deep copy of an object or array, assuring that there is at most
    one instance of each object or array in the resulting structure. The
    duplicate references (which might be forming cycles) are replaced with
    an object of the form
      {$id: id}
    where the id is a simple string
Modified from Douglas Crockford's cycle.js (https://github.com/douglascrockford/JSON-js/blob/master/cycle.js)
Ported over to TypeScript, and modified to handle the reference schema that Json.NET uses.
*/
export function decycle(obj) {
    const catalog = []; // Keep a reference to each unique object or array
    const newObj = getDecycledCopy(obj, catalog);
    return newObj;
}
/** Restore an object that was reduced by decycle. Members whose values are objects of the form
     {$ref: id}
are replaced with references to the value found by the id. This will
restore cycles. The object will be mutated.
So,
     let s = '{$id:1, members: [{$ref:"1"}]';
     return retrocycle(JSON.parse(s));
produces an object containing an array which holds the object itself.
*/
export function retrocycle(obj) {
    const catalog = [];
    findReferences(obj, catalog);
    return resolveReferences(obj, catalog, []);
}
//# sourceMappingURL=resolveReferences.js.map